module.exports = __webpack_public_path__ + "static/media/AbrilFatface-Regular.99ad7968.otf";